import React from "react";
import { PropTypes } from "prop-types";
import { MrbPreviewPage, MrbPageContentHeader } from "mrb/components/layout";
import { LoadioArtistPreviewAlbumList } from "administration/loadio/components";
import { MrbContentLoader, MrbHeaderLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { Image, ToggleActionsLoader } from "common/components";
import { MrbToggle } from "mrb";

function LoadioArtistPreviewTemplate({ loadioArtistPreviewViewStore, t }) {
    const { item, loaderStore, coverImageUrl, toggleIsActive } = loadioArtistPreviewViewStore;

    return (
        <MrbPreviewPage store={loadioArtistPreviewViewStore} contentClassNameExtend="u-padd--none" t={t}>
            <MrbPageContentHeader classNameOverride="c-content__header--primary">
                <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <MrbHeaderLoader />}>
                    {() => (
                        <React.Fragment>
                            <div className="c-content__header--primary__img">
                                <div className="u-animation--fadeIn">
                                    <Image src={coverImageUrl} />
                                </div>
                            </div>
                            <div className="c-content__header--primary__info">
                                <div className="u-animation--fadeIn">
                                    <div className="u-mar--bottom--sml">
                                        <p className="u-type--sml u-type--color--opaque">
                                            {t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.FIELDS.NAME")}
                                        </p>
                                        <p className="c-content__header--primary__title">{item.name}</p>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </MrbContentLoader>
            </MrbPageContentHeader>

            <div className="c-container--sidebar u-display--flex--ai--flex-start">
                <LoadioArtistPreviewAlbumList
                    loadioArtistPreviewViewStore={loadioArtistPreviewViewStore}
                    innerList
                    t={t}
                />
                <div className="c-card--primary u-mar--bottom--med">
                    <MrbContentLoader
                        loaderStore={loaderStore}
                        loaderRender={() => <ToggleActionsLoader lineheight={25} rows={5} sidebarLrg />}
                    >
                        {() => (
                            <div className="u-animation--fadeIn">
                                <div className="c-sidebar__item">
                                    <div className="u-type--base">
                                        {t("ADMINISTRATION.LOADIO.ARTIST.PREVIEW.BUTTONS.STATUS")}
                                    </div>
                                    <MrbToggle
                                        id="naki-nigun-artist-active-status"
                                        value={item.isActive}
                                        onChange={(event) => toggleIsActive(event.target.checked)}
                                    />
                                </div>
                            </div>
                        )}
                    </MrbContentLoader>
                </div>
            </div>
        </MrbPreviewPage>
    );
}

LoadioArtistPreviewTemplate.propTypes = {
    loadioArtistPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(LoadioArtistPreviewTemplate);
